module.exports = __webpack_public_path__ + "img/empty.62bf65e2.png";